import React, { Component, Fragment } from 'react';
import { compose } from 'redux';
import { connect } from "react-redux";
import { Formik } from 'formik';

import { Grid } from '@material-ui/core';
import _ from 'lodash'
import moment from 'moment';

import { calculateLoanProceeds, downloadLoanProceeds, getLoanProceedAssumptions, getLoanProceedAssumptionsByDealId, getDealPropertyProjections, loanProceedsCalculatorResetTestData } from "../refiCashoutCalculator.store";
import { getConfigItemByParentId } from 'store/state/configItems';

import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';

import { PARALLEL_SHOCK, MARKET_EXPECTATIONS_SHOCK } from "../loanProceedsConstants";
import { INTEREST_RATE_TYPE, FLOATING_INDICES, FIXED_INDICES } from "constants/configItemParents";
import { setConfigItemListState } from "components/Global/Fields/util";

import AssetAssumptionsSection from "./AssetAssumptionsSection";
import LoanAssumptionsSection from "./LoanAssumptionsSection";
import ConstraintsSection from "./ConstraintsSection";
import RateEnvironmentSection from "./RateEnvironmentSection";
import { ModalButtonBar, ParentGridContainer, ResultsGridContainer } from '../styles';
import AnalysisResult from './AnalysisResult';

class LoanProceedsModal extends Component {
  state = {
    interestRateTypes: [],
    floatingIndices: [],
    fixedIndices: [],
    formikKey: 0,
    shouldRefreshAssumptions: true,
  }

  componentDidMount() {
    this.props.getLoanProceedAssumptionsByDealId({ dealId: this.props.dealId });
    this.props.getDealPropertyProjections({ dealId: this.props.dealId });

    this.props.getLoanProceedAssumptions();
    this.props.getConfigItemByParentId({ id: INTEREST_RATE_TYPE });
    this.props.getConfigItemByParentId({ id: FLOATING_INDICES });
    this.props.getConfigItemByParentId({ id: FIXED_INDICES });
  }

  componentDidUpdate(prevProps) {
    if (this.props.configItems && this.props.configItems.configItemByParent) {
      setConfigItemListState(INTEREST_RATE_TYPE, "interestRateTypes", this);
      setConfigItemListState(FLOATING_INDICES, "floatingIndices", this);
      setConfigItemListState(FIXED_INDICES, "fixedIndices", this);
    }
    if (this.props.loanProceedAssumptionsForDeal != prevProps.loanProceedAssumptionsForDeal) {
      this.setState({ shouldRefreshAssumptions: true });
    }
  }

  componentWillUnmount() {
    this.props.loanProceedsCalculatorResetTestData();
  }

  createLoanProceedsRequestParameters = (values) => {
    this.setState({ shouldRefreshAssumptions: false });
    const {
      UwRate,
      amortizationTerm,
      debtYield,
      dscr,
      futureCapRate,
      interestRateType,
      rateIndex,
      loanTerm,
      loanType,
      maxLTV,
      projectedNOI,
      shockType,
      shockValue,
      spread,
    } = values;


    const loanProceedsRequestParameters = {};

    const loanProceedsRequest = {};
    loanProceedsRequest.subKey = this.props.dealId;

    loanProceedsRequest.calculationDate = moment(values.calculationDate).format("YYYY-MM-DD");

    loanProceedsRequest.shockType = !shockType ? MARKET_EXPECTATIONS_SHOCK : shockType;


    loanProceedsRequest.shockValue = parseFloat(shockValue);

    if (shockType === PARALLEL_SHOCK && values.shockValue && values.shockValue !== 0) {
      const parallelValue = parseFloat(shockValue) * 0.0001;
      loanProceedsRequest.shockValue = parallelValue;
    }

    if (shockType === MARKET_EXPECTATIONS_SHOCK)
      delete loanProceedsRequest.shockValue;

    if (futureCapRate) loanProceedsRequest.futureCapRate = this.transformRate(futureCapRate);
    loanProceedsRequest.projectedNOI = projectedNOI;

    loanProceedsRequest.loanType = loanType;
    loanProceedsRequest.loanTerm = loanTerm;
    loanProceedsRequest.amortizationTerm = amortizationTerm;
    if (spread) loanProceedsRequest.spread = this.transformRate(spread);
    loanProceedsRequest.interestRateType = interestRateType;
    loanProceedsRequest.rateIndex = rateIndex;
    if (UwRate) loanProceedsRequest.UwRate = this.transformRate(UwRate);

    if (debtYield) loanProceedsRequest.debtYield = this.transformRate(debtYield);
    loanProceedsRequest.dscr = dscr;
    if (maxLTV) loanProceedsRequest.maxLTV = this.transformRate(maxLTV);

    loanProceedsRequestParameters.loanProceedsRequest = loanProceedsRequest;

    loanProceedsRequestParameters.dealId = this.props.dealId
    loanProceedsRequestParameters.prepaymentDate = moment(values.calculationDate).format("YYYY-MM-DD");

    return loanProceedsRequestParameters
  }


  transformRate = (val) => {
    return +val / 100;
  }
  handleDownload = (values) => {
    const { cashOutResult } = this.props;
    let request = this.createLoanProceedsRequestParameters(values);
    request.callback = () => {
      this.props.downloadLoanProceeds({ dealId: this.props.dealId, assumptions: values, cashOutResult: cashOutResult, loanProceeds: cashOutResult.loanProceedsResult });
    }

    this.props.calculateLoanProceeds(request);
  }

  setLoanProceedAssumptions = (selectedItem, formik) => {
    if (this.props.loanProceedAssumptions || this.props.loanProceedAssumptions.length > 0) {
      const foundloanProceedAssumptions = _.find(this.props.loanProceedAssumptions, { "loanType": selectedItem.value, },) || {};

      formik.values.loanType = foundloanProceedAssumptions.loanType;
      formik.values.loanTerm = foundloanProceedAssumptions.term;
      formik.values.amortizationTerm = foundloanProceedAssumptions.amortization;
      formik.values.spread = foundloanProceedAssumptions.loanSpread ? foundloanProceedAssumptions.loanSpread : "";
      formik.values.interestRateType = foundloanProceedAssumptions.rateTypeId;
      formik.values.rateIndex = foundloanProceedAssumptions.indexId;
      formik.values.UwRate = foundloanProceedAssumptions.UwRate ? foundloanProceedAssumptions.UwRate : "";

      formik.values.debtYield = foundloanProceedAssumptions.minDebtYield ? foundloanProceedAssumptions.minDebtYield : "";
      formik.values.dscr = foundloanProceedAssumptions.minDSCR ? foundloanProceedAssumptions.minDSCR : "";
      formik.values.maxLTV = foundloanProceedAssumptions.maxLTV ? foundloanProceedAssumptions.maxLTV : "";
      this.forceUpdate();
    }
  }

  findProjectionValues = (calculationDate) => {
    const { dealPropertyProjections } = this.props;
    if (!calculationDate) calculationDate = moment();

    if (dealPropertyProjections.length > 0) {
      const found = dealPropertyProjections.sort((a, b) => moment.utc(b.periodDate).unix() - moment.utc(a.periodDate).unix())
        .find(x => {
          const periodDate = moment(x.periodDate);
          return periodDate <= calculationDate;
        });
      return found;
    }
  }

  setLoanProceedAssumptionsForDeal = (initialValues) => {
    if (this.props.loanProceedAssumptionsForDeal) {
      if (this.props.loanProceedAssumptionsForDeal !== "Not Set") {
        const saved = this.props.loanProceedAssumptionsForDeal;

        if (saved.loanType) initialValues.loanType = saved.loanType;
        if (saved.term) initialValues.loanTerm = saved.term;
        if (saved.amortization) initialValues.amortizationTerm = saved.amortization;
        if (saved.loanSpread) initialValues.spread = saved.loanSpread;
        if (saved.rateTypeId) initialValues.interestRateType = saved.rateTypeId;
        if (saved.indexId) initialValues.rateIndex = saved.indexId;
        if (saved.UwRate) initialValues.UwRate = saved.UwRate;

        if (saved.minDebtYield) initialValues.debtYield = saved.minDebtYield;
        if (saved.minDSCR) initialValues.dscr = saved.minDSCR;
        if (saved.maxLTV) initialValues.maxLTV = saved.maxLTV;
      }

    }
  }
  setProjectionValues = (initialValues) => {
    if (this.props.dealPropertyProjections) {
      const foundProjection = this.findProjectionValues();
      if (foundProjection) {
        initialValues.projectedNOI = foundProjection.noi;
        initialValues.futureCapRate = foundProjection.capRate * 100;
      }
    }
  }

  render() {
    if (!this.props.dealPropertyProjections || !this.props.loanProceedAssumptionsForDeal) return null;

    let initialValues = {
      calculationDate: moment(),

      shockType: MARKET_EXPECTATIONS_SHOCK,
      shockValue: "",

      futureCapRate: "",
      projectedNOI: 0.0,

      loanType: "",
      loanTerm: "",
      amortizationTerm: "",
      spread: "",
      interestRateType: "",
      rateIndex: "",
      UwRate: "",

      debtYield: "",
      dscr: "",
      maxLTV: "",
    };

    if (this.state.shouldRefreshAssumptions) {
      this.setProjectionValues(initialValues);
      this.setLoanProceedAssumptionsForDeal(initialValues);
      let request = this.createLoanProceedsRequestParameters(initialValues);
      this.props.calculateLoanProceeds(request);
    }
    const { cashOutResult } = this.props;

    return (
      <Formik
        key={this.state.formikKey}
        initialValues={initialValues}
        enableReinitialize={this.state.shouldRefreshAssumptions}
        validate={values => { let errors = {}; return errors; }}
        onSubmit={(values, { setSubmitting }) => {
          let request = this.createLoanProceedsRequestParameters(values);
          this.props.calculateLoanProceeds(request);
          setSubmitting(false);
        }}
        render={({ values, errors, status, touched, isSubmitting, handleChange, handleBlur, handleSubmit }) => (
          <Fragment>

            <Grid container item xs={12} spacing={8}  >


              <RateEnvironmentSection dealPropertyProjections={this.props.dealPropertyProjections} findProjectionValues={this.findProjectionValues} />

              <ModalButtonBar item xs={3}>
                <PrimaryButton onClick={handleSubmit}>Calculate</PrimaryButton>
                <SecondaryButton onClick={() => this.handleDownload(values)}>PDF</SecondaryButton>
              </ModalButtonBar>

            </Grid>
            <ParentGridContainer>
              <Grid container item xs={12}>
                <Grid container item xs={3}>
                  <LoanAssumptionsSection setLoanProceedAssumptions={this.setLoanProceedAssumptions} interestRateTypes={this.state.interestRateTypes} floatingIndices={this.state.floatingIndices} fixedIndices={this.state.fixedIndices} />
                </Grid>
                <Grid container item xs={3}>
                  <AssetAssumptionsSection />
                  <ConstraintsSection />
                </Grid>
                <Grid item xs={6}>
                  {cashOutResult && <ResultsGridContainer><AnalysisResult cashOutResult={cashOutResult} loanProceeds={cashOutResult.loanProceedsResult} /></ResultsGridContainer>}
                </Grid>
              </Grid>
            </ParentGridContainer>
          </Fragment>
        )} />

    );
  }
}


function mapStateToProps({ refiCashoutCalculator, configItems }, ownProps) {
  return {
    ...refiCashoutCalculator
    , configItems
  }
}

export default compose(
  connect(
    mapStateToProps,
    {
      calculateLoanProceeds,
      downloadLoanProceeds,
      getLoanProceedAssumptions,
      getLoanProceedAssumptionsByDealId,
      getConfigItemByParentId,
      getDealPropertyProjections,
      loanProceedsCalculatorResetTestData,
    }
  ))(LoanProceedsModal);
